import { BindCampaignDialogController } from './bind-campaign-dialog.controller'

function bindCampaignDialog () {
  return {
    restrict: 'E',
    templateUrl: '/core/dialogs/bind-campaign/bind-campaign-dialog.html?$$REVISION$$',
    controller: BindCampaignDialogController
  }
}

export { bindCampaignDialog }
